import React, { ReactElement, useMemo } from 'react';
import { Box } from '@mui/material';
import { mergeSx } from 'merge-sx';

import { errorIcon, innerIcon } from '..';
import { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';
import {
  iconBaseSx,
  getIconStatusSx,
  errorIconContainerSx,
} from '../styles';

interface ProtocolItemResultIconProps {
  status: ComplianceAnswerOption;
}

function ProtocolItemResultIcon(
  props: ProtocolItemResultIconProps
): ReactElement {
  const { status } = props;
  const icon = useMemo(() => innerIcon[status], [status]);

  return (
    <Box sx={mergeSx(iconBaseSx, getIconStatusSx(status))}>{icon}</Box>
  );
}

export const MemoProtocolItemResultIcon = React.memo(
  ProtocolItemResultIcon
);

export function ProtocolItemErrorIcon(): ReactElement {
  return <Box sx={errorIconContainerSx}>{errorIcon}</Box>;
}
